import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: 'fas fa-briefcase', url: 'mailto:melgar@polymath.com?subject=Professional%20Inquiry', label: 'Professional Inquiry' },
    { icon: 'fas fa-lightbulb', url: 'mailto:melgar@polymath.com?subject=Share%20Insights', label: 'Share Insights' },
    { icon: 'fas fa-microphone', url: 'mailto:melgar@polymath.com?subject=Media%20Request', label: 'Media & Interviews' },
    { icon: 'fas fa-handshake', url: 'mailto:melgar@polymath.com?subject=Collaboration', label: 'Collaboration' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p>&copy; {currentYear} The Polymath. All rights reserved.</p>
          <div className="footer-social">
            {socialLinks.map((link, index) => (
              <a 
                key={index} 
                href={link.url}
                className="footer-social-link"
                aria-label={link.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className={link.icon}></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

